import { enableKeepingDrawerOpenAfterApproveOrReject } from "../../../../lib/featbit";
import { FlowAction } from "../../layers/bill-info-popup/FlowAction";
var actionsOfTransferingState = [
    FlowAction.Reject,
    FlowAction.Agree,
    FlowAction.StartSignature,
    FlowAction.ShiftNode,
    FlowAction.ShiftApprove,
    FlowAction.AddNode,
    FlowAction.AddSignNode,
    FlowAction.AdminShiftNode,
    FlowAction.Receive,
    FlowAction.ReceiveException,
    FlowAction.Send,
    FlowAction.AddExpress,
    FlowAction.CancelReceiveException,
    FlowAction.Pay,
    FlowAction.Withdraw,
    FlowAction.SkipSend,
    FlowAction.Back,
    FlowAction.Retract,
    FlowAction.AdminBack,
    FlowAction.AdminAddNode,
    FlowAction.MarkedRead,
    FlowAction.Submit,
    FlowAction.Nullify,
    FlowAction.Alter,
    FlowAction.AdminSkipNode,
    FlowAction.Delete,
];
export var isActionOfTransferingState = function (action, filterPredicate) {
    var _actions = filterPredicate ? actionsOfTransferingState.filter(filterPredicate) : actionsOfTransferingState;
    return _actions.includes(action);
};
export var isActionOfNotNeedRefresh = function (actionName) {
    var ACTIONS_OF_NEED_NOT_REFRESH = [
        FlowAction.Copy,
        FlowAction.Print,
        FlowAction.PrintInvoice,
        FlowAction.Suspend,
        FlowAction.Urge,
        FlowAction.ExportAttachment,
        FlowAction.Share,
        FlowAction.RemindAddingInvoice,
        FlowAction.Nullify,
        FlowAction.Delete,
    ];
    return ACTIONS_OF_NEED_NOT_REFRESH.includes(actionName);
};
export var isMofiyAction = function (action) {
    return action === FlowAction.Modify;
};
export var isActionKeepDrawerOpen = function (action) {
    if (enableKeepingDrawerOpenAfterApproveOrReject()) {
        return [FlowAction.Agree, FlowAction.Reject].includes(action);
    }
    return false;
};
